
import { useNavigate } from "react-router-dom";
import { IGarantie, IOptionCotisation, IRERequestDataOffers } from "../../context/model";
import StickButtonsBloc from "../common/StickButtonsBloc";
import useAppState from "../../context/AppContext";
import { APP_RETIREMENT_URLS, ERROR_MESSAGES } from "../../const/AppConst";
import REGuarantyOfferFormComponent from "../../components/retirement/guaranty/REGuarantyOfferFormComponent";
import REGuarantyCompareFormComponent from "../../components/retirement/guaranty/REGuarantyCompareFormComponent";
import { useEffect, useState } from "react";
import { calculOffersRetired } from "../../utils/dataUtils";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from 'yup';
import { getInfoRetirementSteps } from "../../utils/utils";

type GuarantyOfferBlocProps = {
    handleSwitchPage: () => void;
    garanties: IGarantie[];
    isShowComparePage: boolean
}

type  REGuarantyRetirementBlocFormData = {
  offerCode: string
}

export default function REGuarantyRetirementBloc({handleSwitchPage, garanties, isShowComparePage } : Readonly<GuarantyOfferBlocProps>) {

    const navigate = useNavigate();
    const {
      state: { jwtToken, updatedProposition, additionalData, infoSteps, proposition },
      dispatch
    } = useAppState();

    const [offers, setOffers] = useState<IOptionCotisation[]>([]);

    const validationSchema = Yup.object().shape({
      offerCode: Yup.string().required(ERROR_MESSAGES.requiredMsg)
    });

  const {
    register,
    handleSubmit, 
    setValue, 
    watch,
    formState: { errors },
  } = useForm<REGuarantyRetirementBlocFormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      offerCode : updatedProposition?.offerCode ?? "",
    },
    resolver: yupResolver(validationSchema),
  });


    useEffect(() => {
      const fetchTotal = async () => {
        if (jwtToken) {
          const token = jwtToken.accessToken;
          const body = {
            principalMemberInfo: {
              retiredDate: updatedProposition?.retirementDate,
              birthDate: updatedProposition?.birthDate,
              hasAlsaceMoselle: updatedProposition?.alsaceMoselleRegime
            },
            partnerInfo: additionalData?.hasPartner ? additionalData?.partnerInfo : null,
            childrenInfo: additionalData?.children,
            effectiveDate: updatedProposition?.effectiveDate,
            coveragesInfo: updatedProposition?.coveragesInfo
          } as IRERequestDataOffers;
          
          const result = await calculOffersRetired(token, body);
          setOffers(result);
        }
      } 
  
      fetchTotal();
  }, []);
    const onNextAction = async (data: REGuarantyRetirementBlocFormData) => {
      let tempUpdatedPropo = updatedProposition;
      if(tempUpdatedPropo) {
        tempUpdatedPropo.offerCode = data.offerCode;
      }
           const hasDocFamilyStep = getInfoRetirementSteps
        (infoSteps, "INFO_FAMILY_DOC", 
          (additionalData?.hasChild ||additionalData?.hasPartner) ??false,
          "INFO_LASTEMPLOYEE_DOC"
        );
    
        if (hasDocFamilyStep.hasChanged) {
          dispatch({type: "UPDATE_STEPS", 
            steps: hasDocFamilyStep.infoSteps
          })
        }
      
        if (isShowComparePage !== true) {
            handleSwitchPage();
        } else {
            const nextUrl = APP_RETIREMENT_URLS.infoIdentityPage
     
            dispatch({type: 'NEXT_INFO_STEP', path: nextUrl, updatedProposition: tempUpdatedPropo});
            navigate({
                pathname: nextUrl,
                search: `?id=${proposition!.propositionId}`,
            });  
        }       
    }


    const onPreviousAction = async () => {
      if (!isShowComparePage) {
        const url = APP_RETIREMENT_URLS.besoinPage
     
        dispatch({type: 'BACK_INFO_STEP', path: url});
        navigate({
            pathname: url,
            search: `?id=${proposition!.propositionId}`,
        });   
      } else {
        handleSwitchPage();
      }
            
    }

    const handleChooseOffer = (e: any, option: string) => { 
      e.preventDefault();
      setValue('offerCode' , option, {shouldValidate : true, });
    };

      return (
        <div className="">
          <div className="">
            {
              isShowComparePage ?
              <REGuarantyCompareFormComponent  
                garanties={garanties} 
                handleSwitchPage={handleSwitchPage} 
                offers={offers} 
                offerCode={watch('offerCode')} 
                errors={errors} 
                handleChooseOffer={handleChooseOffer} 
                register={register}/> 
              :
              <REGuarantyOfferFormComponent 
                garanties={garanties} 
                handleSwitchPage={handleSwitchPage} 
                offers={offers} 
                offerCode={watch('offerCode')} 
                errors={errors} 
                handleChooseOffer={handleChooseOffer}/>
            }
            
          </div>
          
          <StickButtonsBloc 
              showPreviousButton={true} 
              disabledPreviousButton={false} 
              nextAction={handleSubmit(onNextAction)} 
              showNextButton={true} 
              previousAction={onPreviousAction}
            />
        </div>
      )
}